if (!customElements.get("share-button")) {
    customElements.define(
        "share-button",
        class ShareButton extends HTMLElement {
            constructor() {
                super();

                this.button = this.querySelector("button");
                this.notification = this.querySelector(".share-button__notification");
                this.urlToShare = window.shareUrl ? window.shareUrl : document.location.href;

                if (navigator.share) {
                    this.classList.add("-native");
                    this.button.addEventListener("click", () => {
                        navigator.share({ url: this.urlToShare, title: document.title });
                    });
                } else {
                    this.classList.add("-fallback");
                    this.button.addEventListener("click", this.copyToClipboard.bind(this));
                }
            }

            copyToClipboard() {
                navigator.clipboard.writeText(this.urlToShare).then(() => {
                    this.notification.classList.add("-animate", "-active");
                    setTimeout(() => {
                        this.notification.classList.remove("-active");
                    }, 3000);
                });
            }
        }
    );
}
